import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ITransactionsDistinctRecipients } from 'store/transactionsDistinctRecipients/types';
import { initialState } from 'store/transactionsDistinctRecipients/initialState';

export const transactionsDistinctRecipientsSlice = createSlice({
  name: 'transactionsRecipients',
  initialState,
  reducers: {
    start: state => {
      state.isLoading = true;
      state.error = null;
    },

    success: (state, action: PayloadAction<ITransactionsDistinctRecipients>) => {
      state.data = action.payload;
      state.isLoading = false;
    },

    error: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isLoading = false;
    },

    cleanUp: state => {
      state.data = initialState.data;
      state.error = initialState.error;
      state.isLoading = initialState.isLoading;
    },
  },
});

export const { start, success, error, cleanUp } = transactionsDistinctRecipientsSlice.actions;

export default transactionsDistinctRecipientsSlice.reducer;
